import { createFileRoute } from '@tanstack/react-router'
import { AuditorApiAccessPage } from '@/components/auditor-center/AuditorCenterPage'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/auditor-center/api-access'
)({
  component: AuditorApiAccessPage,
})
